let language = {

    QUILL_KEYBOARD_SHORTCUTS_MODAL_TITLE: "键盘快捷键",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_TITLE: "默认快捷键，Ctrl + 字母：",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_HEAD_LATTER: "字母",
    QUILL_KEYBOARD_SHORTCUTS_MODAL_DEFAULT_SHORTCUTS_HEAD_ACTION: "操作",
    QUILL_KEYBOARD_SHORTCUTS_UNDERLINE: "下划线",
    QUILL_KEYBOARD_SHORTCUTS_ITALIC: "斜体",
    QUILL_KEYBOARD_SHORTCUTS_COPY: "复制",
    QUILL_KEYBOARD_SHORTCUTS_SELECT_ALL: "全选",
    QUILL_KEYBOARD_SHORTCUTS_REDO: "重做",
    QUILL_KEYBOARD_SHORTCUTS_BOLD: "加粗",
    QUILL_KEYBOARD_SHORTCUTS_CUT: "剪切",
    QUILL_KEYBOARD_SHORTCUTS_PASTE: "粘贴",
    QUILL_KEYBOARD_SHORTCUTS_UNDO: "撤销",
    QUILL_KEYBOARD_SHORTCUTS_UNDO_INSERT: "插入/编辑链接",

};

export { language }
